import { all, call, put, takeLatest } from 'redux-saga/effects';
import { request } from '../../../common/util/RestClient';
import {
  disconnectIntegration,
  fetchZendeskEntityMapping,
  fetchZendeskProperties,
  validateIntegration,
  zedeskAuthentication,
  zendeskEntityMapping,
} from '../../routines/integrations/zendeskRoutines';
import envConfig from '../../../config';

export function* zedeskAuthenticationSaga({ payload }) {
  try {
    const URL = `${envConfig.APIG_URL}zendesk/configs/authentication`;
    const authConfig = {
      method: 'POST',
      payload,
    };
    const response = yield call(request, URL, authConfig);
    yield put(zedeskAuthentication.success(response));
  } catch (error) {
    yield put(zedeskAuthentication.failure({ error, noAlert: true }));
  } finally {
    yield put(zedeskAuthentication.fulfill());
  }
}
export function* zendeskEntityMappingSaga({ payload }) {
  try {
    const URL = `${envConfig.APIG_URL}zendesk/configs/entity-mapping`;
    const mappingConfig = {
      method: 'POST',
      payload,
    };
    const { data } = yield call(request, URL, mappingConfig);
    yield put(
      zendeskEntityMapping.success({
        data,
      })
    );
  } catch (error) {
    yield put(zendeskEntityMapping.failure({ error, noAlert: true }));
  } finally {
    yield put(zendeskEntityMapping.fulfill());
  }
}

export function* validateZendeskIntegrationSaga() {
  try {
    const URL = `${envConfig.APIG_URL}zendesk/configs/validation`;
    const response = yield call(request, URL);
    yield put(validateIntegration.success(response));
  } catch (error) {
    yield put(validateIntegration.failure({ error, noAlert: true }));
  } finally {
    yield put(validateIntegration.fulfill());
  }
}

export function* disconnetZendeskIntegrationSaga() {
  try {
    const URL = `${envConfig.APIG_URL}zendesk/configs/disable`;
    const response = yield call(request, URL);
    yield put(disconnectIntegration.success(response));
  } catch (error) {
    yield put(disconnectIntegration.failure({ error }));
  } finally {
    yield put(disconnectIntegration.fulfill());
  }
}

export function* fetchZendeskEntityMappingSaga() {
  try {
    const URL = `${envConfig.APIG_URL}zendesk/configs/entity-mapping`;
    const { data } = yield call(request, URL);
    yield put(fetchZendeskEntityMapping.success(data));
  } catch (error) {
    yield put(fetchZendeskEntityMapping.failure({ error }));
  } finally {
    yield put(fetchZendeskEntityMapping.fulfill());
  }
}

function* fetchZendeskPropertiesSaga() {
  try {
    const URL = `${envConfig.APIG_URL}zendesk/configs/properties`;
    const { data } = yield call(request, URL);
    yield put(fetchZendeskProperties.success({ ...data }));
  } catch (error) {
    yield put(fetchZendeskProperties.failure({ error }));
  }
}
export default function* root() {
  yield all([
    takeLatest(zedeskAuthentication.TRIGGER, zedeskAuthenticationSaga),
    takeLatest(zendeskEntityMapping.TRIGGER, zendeskEntityMappingSaga),
    takeLatest(validateIntegration.TRIGGER, validateZendeskIntegrationSaga),
    takeLatest(disconnectIntegration.TRIGGER, disconnetZendeskIntegrationSaga),
    takeLatest(
      fetchZendeskEntityMapping.TRIGGER,
      fetchZendeskEntityMappingSaga
    ),
    takeLatest(fetchZendeskProperties.TRIGGER, fetchZendeskPropertiesSaga),
  ]);
}
